import { Node } from 'reactflow';
import { MenuItem, Select, SelectChangeEvent, Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CallsMenuStageType } from '@bandido/shared/constants';
import { CommunicationType, StageNodeData } from '@bandido/shared/types';

import { WELCOME_MESSAGE } from '@frontend/features/calls-menu/constants';

interface StageFormProps {
  stage: Node<StageNodeData>;
  onTextChange: (field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSelectChange: (field: string) => (e: SelectChangeEvent) => void;
  onCommunicationTypeChange?: (type: CommunicationType) => void;
}

export const StageForm = ({ stage, onTextChange, onSelectChange, onCommunicationTypeChange }: StageFormProps) => {
  const { t } = useTranslation();
  const element = stage?.type === CallsMenuStageType.ACTION ? 'action' : 'menu';

  const handleCommunicationTypeChange = (e: SelectChangeEvent) => {
    const newType = e.target.value as CommunicationType;

    if (onCommunicationTypeChange) {
      onCommunicationTypeChange(newType);
    } else {
      onSelectChange('communicationType')(e);
    }
  };

  return (
    <>
      <Stack className="nodrag" display="flex" flexDirection="column" gap={2}>
        <Stack gap={1}>
          <Typography variant="subtitle2">{t(`callsMenu.selectedStage.${element}.label`)}</Typography>
          <TextField
            disabled={stage?.data.isMain}
            value={stage?.data?.name === WELCOME_MESSAGE ? t(`callsMenu.${WELCOME_MESSAGE}`) : stage?.data?.name}
            onChange={onTextChange('name')}
            size="small"
            name="name"
            fullWidth
            placeholder={t(`callsMenu.selectedStage.${element}.label`)}
            variant="outlined"
          />
        </Stack>
      </Stack>
      {stage?.type !== CallsMenuStageType.ACTION && (
        <Stack display="flex" flexDirection="column" gap={2}>
          <Stack gap={1}>
            <Typography variant="subtitle2">{t('callsMenu.selectedStage.communicationType.title')}</Typography>
            <Select
              className="nodrag"
              size="small"
              value={stage?.data?.communicationType || ''}
              onChange={handleCommunicationTypeChange}
            >
              <MenuItem value={CommunicationType.TEXT_TO_SPEECH}>
                {t(`callsMenu.selectedStage.communicationType.types.${CommunicationType.TEXT_TO_SPEECH}`)}
              </MenuItem>
              <MenuItem value={CommunicationType.AUDIO_RECORD}>
                {t(`callsMenu.selectedStage.communicationType.types.${CommunicationType.AUDIO_RECORD}`)}
              </MenuItem>
              <MenuItem value={CommunicationType.AUDIO_FILE}>
                {t(`callsMenu.selectedStage.communicationType.types.${CommunicationType.AUDIO_FILE}`)}
              </MenuItem>
            </Select>
          </Stack>
        </Stack>
      )}
    </>
  );
};
